module.exports = __webpack_public_path__ + "img/InternalIgnitionDetailed-min.41e3c10e.png";